<script setup lang="ts"></script>

<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
      fill="#004493"
    />
    <path
      d="M14.189 35.07C13.5712 35.0683 12.9789 34.8229 12.541 34.387C12.318 34.1688 12.1444 33.9053 12.0319 33.6143C11.9194 33.3232 11.8707 33.0115 11.889 32.7V7.82099C11.8994 7.23342 12.1351 6.67228 12.5472 6.2534C12.9594 5.83453 13.5167 5.58989 14.104 5.56999H26.644C26.9387 5.56746 27.2306 5.62696 27.5007 5.74464C27.7708 5.86231 28.0132 6.03551 28.212 6.25299C28.6188 6.67431 28.8489 7.23537 28.855 7.82099V32.66C28.8784 33.2613 28.6636 33.8476 28.2573 34.2915C27.8511 34.7354 27.2861 35.0012 26.685 35.031H26.485L14.189 35.07ZM14.627 7.05699H14.305C14.0814 7.02663 13.8549 7.08544 13.6743 7.22072C13.4938 7.356 13.3737 7.5569 13.34 7.77999V32.62C13.3213 32.7332 13.3253 32.8489 13.3516 32.9606C13.3778 33.0723 13.426 33.1776 13.4932 33.2706C13.5604 33.3636 13.6454 33.4423 13.7432 33.5023C13.841 33.5622 13.9497 33.6022 14.063 33.62H26.443C27.166 33.62 27.488 33.339 27.488 32.575V7.98199C27.5084 7.75833 27.4395 7.53569 27.2964 7.36261C27.1532 7.18952 26.9475 7.08003 26.724 7.05799H25.8C25.7378 7.38396 25.5532 7.67378 25.2842 7.86807C25.0152 8.06236 24.682 8.14641 24.353 8.10299H16.516C16.1808 8.156 15.8382 8.07646 15.5606 7.88122C15.2831 7.68597 15.0924 7.39037 15.029 7.05699H14.627Z"
      fill="white"
    />
  </svg>
</template>

<style scoped></style>
